module.exports = __webpack_public_path__ + "img/Feature.3fb28d7c.jpg";